import {useMemo} from 'react';
import {GeoHubRestaurant, GeoHubViewModel, getGeoHubViewModel} from '../data/geoHubData';
import {getGeoCityPlacesSnapshot, getHubRestaurantsFromSnapshot} from '../data/geoCityPlacesData';
import {GeoCityConfig} from '../data/geoRoutes';

export type GeoCityHubState = {
    hub: GeoHubViewModel | undefined;
    restaurants: GeoHubRestaurant[];
    dataSource: 'snapshot' | 'static';
    snapshotFetchedAt?: string;
};

export function useGeoCityHub(geo: GeoCityConfig): GeoCityHubState {
    const staticHub = useMemo(() => getGeoHubViewModel(geo), [geo]);

    const snapshot = useMemo(
        () => getGeoCityPlacesSnapshot(geo.restaurantsDataKey),
        [geo.restaurantsDataKey],
    );

    const snapshotRestaurants = useMemo(
        () => getHubRestaurantsFromSnapshot(geo.restaurantsDataKey),
        [geo.restaurantsDataKey],
    );

    const restaurants = snapshotRestaurants ?? staticHub?.restaurants ?? [];
    const dataSource = snapshotRestaurants ? 'snapshot' : 'static';

    const hub: GeoHubViewModel | undefined = staticHub
        ? {
              ...staticHub,
              restaurants,
          }
        : undefined;

    return {
        hub,
        restaurants,
        dataSource,
        snapshotFetchedAt: snapshot?.fetchedAt,
    };
}
